<template>
  <div class="firmwareDetails">
    <setting-header v-if="selectedCam" />
    <header></header>
    <v-btn
      v-if="!isEdit && canConfigCamera"
      icon
      class="detailCamsSetting_edit"
    >
      <div
        class="icon icon-3dots"
        @click="
          navigateTo({
            name: 'settings-firmware-details-edit',
            params: { id: $route.params.id },
          })
        "
      />
    </v-btn>
    <v-divider class="firmwareDetails_divider" />
    <section
      class="firmwareDetails_wrapper"
      :class="{ inMotionMode: isMotion }"
    >
      <main v-if="!isEdit">
        <section v-if="!isMotion" class="firmwareDetails_left">
          <section>
            <h3>カメラ情報</h3>
            <div
              v-for="(item, index) in visibleItems"
              :key="index"
              class="firmwareDetails_left--items"
            >
              <div class="d-flex">
                <span class="firmwareDetails_left--label">
                  {{ item.label }}
                </span>
                <tooltip :classes="'firmwareDetails_tooltip'">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" class="text-truncate" v-on="on">
                      {{ item.text }}
                    </div>
                  </template>
                  <h2>{{ item.text }}</h2>
                </tooltip>
              </div>
              <div
                v-if="item.updating"
                class="firmwareDetails_left--itemsPackage"
              >
                <div class="d-flex">
                  <span class="firmwareDetails_left--label"> </span>
                  <h2>{{ item.updatingLable }}</h2>
                </div>
              </div>
              <div
                v-if="item.updateVersion && !item.updating && isAdmin"
                class="firmwareDetails_left--itemsPackage"
              >
                <div
                  class="d-flex firmwareDetails--pointer"
                  @click="handleUpdateFirmware(item)"
                >
                  <span class="firmwareDetails_left--label">
                    {{ item.updateLabel }}
                  </span>
                  <tooltip :classes="'firmwareDetails_tooltip'">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" class="text-truncate" v-on="on">
                        {{ item.updateVersion }}
                      </div>
                    </template>
                    <h2>{{ item.updateVersion }}</h2>
                  </tooltip>
                </div>
                <span>{{ item.updateNotice }}</span>
              </div>
            </div>
          </section>
          <v-skeleton-loader
            v-if="loadingRecordSettings"
            :loading="loadingRecordSettings"
            type="table-heading, paragraph"
          ></v-skeleton-loader>
          <firmware-settings-details
            v-else-if="canConfigCamera"
            ref="firmawareDetails"
            :route-from="routeFrom"
            @reconnectCam="reconnectCam"
          >
            <template v-slot:append>
              <v-btn
                class="firmwareDetails_btn-reset"
                text
                @click="handleOpenRebootDialog"
                >カメラの再起動</v-btn
              >
              <v-divider class="firmwareDetails_divider" />
            </template>
          </firmware-settings-details>
        </section>
        <section class="firmwareDetails_right">
          <section
            class="firmwareDetails_cam"
            :class="{ inMotionMode: isMotion }"
          >
            <video-stream
              v-if="selectedCam && showVideo && !!selectedCam.sessionToken"
              :id="selectedCam.id"
              :stream-config="{
                accessKeyId: iamKey,
                secretAccessKey: iamSecret,
                streamName: selectedCam.kvsVideoStreamName,
                region: selectedCam.awsRegionName,
                autoplay: true,
                refreshOnSessionChange: true,
              }"
              :meta="selectedCam"
              :title="selectedCam.name"
              :signal.sync="selectedCam.signal"
              main
              :multiple-area="areaList"
              :disable-zoom="true"
              zoomout-on-restore
              show-skeleton
              controller-size="small"
              :show-controllers="isMotion"
              :show-motion-areas="isMotion"
              :hide-display-controller="true"
              @onLowLatencyError="handleLowLatencyError"
              @onCameraStatus="handleCamStatus"
              @loadedmetadata="handleLoadMetadata"
              @onAction="handleVideoStreamEvent"
            >
            </video-stream>
          </section>
          <h5 v-if="selectedCam && showVideo && !isMotion">
            {{ selectedCam.name }}
          </h5>
        </section>
        <v-skeleton-loader
          v-if="isMotion && cameraStatus && loadingRecordSettings"
          class="firmwareDetails_motionItemsLoading"
          :loading="loadingRecordSettings"
          type="table-heading, paragraph"
        ></v-skeleton-loader>
        <FirmwareMotionAreas
          v-else
          ref="motionAreas"
          :is-motion="isMotion"
          :motion-detection="motionDetection"
          :clear-areas="clearAreas"
          :sensitivity="motionSensitivities[selectedMotionSensitivity].val"
          :video-metadata="videoMetadata"
          @updateAreaList="updateAreaList"
          @disableMotion="confirmDisableMotion = true"
        ></FirmwareMotionAreas>
      </main>
      <div v-else>
        <span class="editCamsSetting_name">名前</span>
        <v-text-field
          v-model="newCamName"
          height="40px"
          color="dark"
          class="editCamsSetting_input-name"
          required
          dense
          outlined
          placeholder=""
          full-width
          :maxlength="50"
          @blur="handleCameraName"
          @keyup="validateInput"
        />
      </div>
      <div
        v-if="isMotion && !loadingRecordSettings"
        class="firmwareDetails_motionConfig"
      >
        <div class="d-flex justify-space-between motionConfig-item">
          <span class="motionConfig-item--name">動体検知</span>
          <div class="motionConfig-item--switch">
            <v-switch
              v-model="motionDetection"
              :ripple="false"
              :disabled="loadingRecordSettings"
              dense
              @click.stop="handleMotionDetection($event)"
            ></v-switch>
          </div>
        </div>
        <div
          v-if="motionDetection"
          class="d-flex justify-space-between motionConfig-item"
        >
          <span class="motionConfig-item--name">動体検知感度</span>
          <div class="">
            <span class="motionConfig-item--label">
              {{ motionSensitivities[selectedMotionSensitivity].text }}
            </span>
            <v-menu
              top
              offset-y
              content-class="firmwareDetails_motion--menu"
              z-index="99"
              nudge-left="45"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  text
                  class="firmwareDetails_motion--menuBtn"
                  :class="{}"
                  v-on="on"
                >
                  <span class="icon icon-3dots" />
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item-group
                  v-model="selectedMotionSensitivity"
                  color="primary"
                  item-text="text"
                  mandatory
                  item-value="val"
                >
                  <v-list-item
                    v-for="(item, index) in motionSensitivities"
                    :key="item.val"
                    dense
                  >
                    <v-list-item-icon>
                      <check-icon-svg
                        no-circle
                        color="#0075c2"
                        :check-color="
                          selectedMotionSensitivity === index
                            ? '#0075c2'
                            : 'transparent'
                        "
                        size="24"
                        class="headerMenu-menu_check v-icon"
                      />
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
      <footer v-if="!isEdit"></footer>
      <footer v-else>
        <v-divider class="editCamsSetting_divider" />
        <section class="editCamsSetting_actions">
          <v-btn
            :loading="submitLoading"
            :disabled="
              !newCamName.length ||
              !isValid ||
              selectedCam.name.trim() === newCamName.trim()
            "
            class="editCamsSetting_submit"
            @click="handleSubmit"
          >
            保存
          </v-btn>
        </section>
      </footer>
    </section>
    <!-- Dialogs -->
    <template>
      <!-- Update firmware dialog -->
      <clip-dialog-a
        :open="dialogUpdateFirmwareOpen"
        title="カメラの再起動"
        @onClose="closeDialogUpdateFirmware"
      >
        <div class="firmwareDetails_dialog-content">
          <span class="firmwareDetails_dialog-content--warn"
            >カメラの再起動中は録画とライブが停止されます</span
          ><br />
          再起動してもよろしいですか？
        </div>
        <template v-slot:actions>
          <v-btn
            class="firmwareDetails_dialog-btn firmwareDetails_dialog-cancel"
            color="text"
            @click="closeDialogUpdateFirmware"
          >
            キャンセル
          </v-btn>
          <v-spacer />
          <v-btn
            class="firmwareDetails_dialog-btn firmwareDetails_dialog-update"
            color="text"
            :loading="rebooting"
            @click="handleRebootCamera"
          >
            再起動する
          </v-btn>
        </template>
      </clip-dialog-a>
      <clip-dialog-a
        :open="confirmDisableMotion"
        :title="'動体検知をOFFにする'"
        @onClose="closeDialogConfirmDisableMotion"
      >
        <div class="clip_dialog-content firmwareDetails_dialog-content">
          動体検知をOFFにすると、設定した<br />
          動体検知エリアの設定も削除されます。
        </div>
        <template v-slot:actions>
          <v-btn
            class="clip_dialog-btn clip_dialog-cancel"
            color="text"
            @click="closeDialogConfirmDisableMotion"
          >
            キャンセル
          </v-btn>
          <v-spacer />
          <v-btn
            class="clip_dialog-btn clip_dialog-delete firmwareDetails-deleteBtn"
            color="text"
            @click="handleDisableMotion"
          >
            OFFにする
          </v-btn>
        </template>
      </clip-dialog-a>
      <clip-dialog-a
        :open="dialogConfirmUpdateFirmware"
        :title="updateWarnTitle"
        @onClose="dialogConfirmUpdateFirmware = false"
      >
        <div class="firmwareCamsTable_dialog-content">
          <span class="firmwareCamsTable_dialog-content--warn">
            {{ updateWarnText }}
          </span>
          <span>更新してもよろしいですか？</span>
        </div>
        <template v-slot:actions>
          <v-btn
            class="firmwareCamsTable_dialog-btn firmwareCamsTable_dialog-cancel"
            color="text"
            @click="dialogConfirmUpdateFirmware = false"
          >
            キャンセル
          </v-btn>
          <v-spacer />
          <v-btn
            class="firmwareCamsTable_dialog-btn firmwareCamsTable_dialog-update"
            color="text"
            :loading="updatingFirmware"
            @click="handleUpdateFirmwareOk"
          >
            更新する
          </v-btn>
        </template>
      </clip-dialog-a>
      <!-- ----------------- -->
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import FirmwareSettingsDetails from './FirmwareSettingsDetails.vue';
import ClipDialogA from '@/components/dialogs/ClipDialogA.vue';
import SettingHeader from '../SettingHeader.vue';
import CheckIconSvg from '@/components/icons/CheckIconSVG.vue';
import FirmwareMotionAreas from '@/views/settings/firmware/FirmwareMotionAreas.vue';
import { updateSettingCameraName } from '@/services/settings.service';
import { dialogService } from '@/services/dialog.service';

import {
  CameraFirmwareType,
  FetchCamRecordInfoKeys,
  KVSErrorCodes,
  PlayerStatus,
} from '@/globals/enums';
import {
  getFirmwareLatestVersion,
  getFullWidthNumericHyphenUnderbar,
  uuidv4,
  validateInputName,
} from '@/utils/helpers';

const SETTING_FIRMWARE_MOTION = 'settings-firmware-motion';

export default {
  name: 'FirmwareDetails',
  components: {
    CheckIconSvg,
    FirmwareSettingsDetails,
    SettingHeader,
    ClipDialogA,
    FirmwareMotionAreas,
  },
  props: {
    routeModel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isValid: false,
      videoMetadata: null,
      fetchCamRecordInfoReqId: null,
      selectedCams: {},
      selectedCam: null,
      showVideo: true,
      dialogUpdateFirmwareOpen: false,
      confirmDisableMotion: false,
      rebooting: false,
      loadingRecordSettings: false,
      routeFrom: null,
      isEdit: false,
      isMotion: false,
      newCamName: '',
      items: [
        {
          name: 'cameraName',
          label: 'カメラ名称',
          text: '老舗書店 銀座支店',
        },
        {
          name: 'serialNumber',
          label: 'シリアル番号',
          text: '',
        },
        {
          name: 'firmwareVersion',
          label: 'ファームウェアバージョン',
          text: '',
          type: CameraFirmwareType.firmware,
          operatingVersion: '',
          updateVersion: '',
          updateLabel: '最新のファームウェアを適用する',
          updating: false,
          updatingLable: 'ファームウェア更新中...',
          updateNotice:
            '※ファームウェアの更新中は録画とライブが停止されますのでご注意ください。',
          hidden: true,
        },
        {
          name: 'packageVersion',
          label: 'パッケージバージョン',
          text: '',
          type: '',
          operatingVersion: '',
          updateVersion: '',
          updating: false,
          updatingLable: 'パッケージ更新中...',
          updateLabel: '最新のパッケージを適用する',
          updateNotice:
            '※パッケージの更新中は録画とライブが停止されますのでご注意ください。',
          hidden: true,
        },
      ],
      submitData: {},
      reconnectCamTimeout: null,
      submitLoading: false,
      motionDetection: false,
      selectedMotionSensitivity: 1,
      defaultMotionSensitivity: 1,
      motionSensitivities: [
        {
          val: 3,
          text: '高感度',
        },
        {
          val: 2,
          text: '中感度',
        },
        {
          val: 1,
          text: '低感度',
        },
      ],
      areaList: [],
      clearAreas: false,
      cameraStatus: null,
      updatingFirmware: false,
      dialogConfirmUpdateFirmware: false,
      updateWarnText: '',
      updateWarnTitle: '',
      firmwareName: '',
    };
  },
  computed: {
    ...mapGetters('common', {
      allCamList: 'allCamList',
    }),
    ...mapState({
      cameraList: (state) => state.common.cameraList,
      iamKey: (state) => state.common.iam.accessKeyId,
      iamSecret: (state) => state.common.iam.secretAccessKey,
      camRecordInfo: (state) => state.settings.camRecordInfo,
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
    }),
    isAdmin() {
      return this.isCurrentAvatarOwner;
    },
    canConfigCamera() {
      return (
        this.isCurrentAvatarOwner || this.selectedCam?.cameraPolicy?.access
      );
    },
    visibleItems() {
      return this.items.filter((item) => !item.hidden);
    },
    id() {
      return this.$route.params.id;
    },
    recordSetting() {
      return this.camRecordInfo[String(this.id)];
    },
    currentRoute() {
      return this.$route.name;
    },
  },
  watch: {
    canConfigCamera: {
      immediate: true,
      handler: function (val) {
        // If the camera is available only for LIVE, hide the firmware and package version
        this.$set(this.items[2], 'hidden', !val); // firmware
        this.$set(this.items[3], 'hidden', !val); // package
      },
    },
    $route(to) {
      this.isEdit = to.name === 'settings-firmware-details-edit';
      this.isMotion = to.name === 'settings-firmware-motion';
      this.newCamName = this.selectedCam.name;
    },
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectedCam = this.cameraList.find(
            (cam) => String(cam.id) === String(val)
          );
        }
      },
    },
    cameraList: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectedCam = val.find(
            (cam) => String(cam.id) === String(this.id)
          );
        }
      },
    },
    selectedCam: {
      handler: function (camera) {
        if (camera) {
          if (!camera.sessionToken) {
            this.attachCamerasCredentials({ ids: [camera.id] });
          }
          // Indexes of this.items
          // Camera name
          this.$set(this.items[0], 'text', camera.name);
          // Serial number
          this.$set(this.items[1], 'text', camera.serialNumber);
          // Operating firmware version
          if (camera.OperatingVersion && camera.OperatingVersion.length) {
            const mappedOperations = getFirmwareLatestVersion(
              camera.OperatingVersion
            );

            // set Firmware
            this.$set(
              this.items[2],
              'text',
              mappedOperations[CameraFirmwareType.firmware]?.version
            );
            this.$set(
              this.items[2],
              'operatingVersion',
              mappedOperations[CameraFirmwareType.firmware]?.version
            );
            // set ArobaView RA
            this.$set(
              this.items[3],
              'type',
              mappedOperations[CameraFirmwareType.arobaViewRa]?.name
            );
            this.$set(
              this.items[3],
              'text',
              mappedOperations[CameraFirmwareType.arobaViewRa]?.version
            );
            this.$set(
              this.items[3],
              'operatingVersion',
              mappedOperations[CameraFirmwareType.arobaViewRa]?.version
            );
          }
          // Update package version
          if (camera.UpdateVersion && camera.UpdateVersion.length) {
            const versionsToUpdate = camera.UpdateVersion.filter(
              (u) =>
                [0, 3].includes(u.updatingState) &&
                [
                  CameraFirmwareType.firmware,
                  CameraFirmwareType.arobaViewRa,
                ].includes(u.name)
            );
            const mappedUpdateVersion =
              getFirmwareLatestVersion(versionsToUpdate);
            if (mappedUpdateVersion[CameraFirmwareType.firmware] !== null) {
              this.$set(
                this.items[2],
                'updateVersion',
                mappedUpdateVersion[CameraFirmwareType.firmware].version
              );
            }
            if (mappedUpdateVersion[CameraFirmwareType.arobaViewRa] !== null) {
              this.$set(
                this.items[3],
                'type',
                mappedUpdateVersion[CameraFirmwareType.arobaViewRa].name
              );
              this.$set(
                this.items[3],
                'updateVersion',
                mappedUpdateVersion[CameraFirmwareType.arobaViewRa].version
              );
            }

            // if firmware is updating (there is an item with `updatingState===1`)
            const firmwareUpdateWithState1 = camera.UpdateVersion.filter(
              (u) =>
                u.updatingState === 1 && u.name === CameraFirmwareType.firmware
            );
            if (firmwareUpdateWithState1.length > 0) {
              this.$set(this.items[2], 'updating', true);
            }
            const arobaViewRaUpdateWithState1 = camera.UpdateVersion.filter(
              (u) =>
                u.updatingState === 1 &&
                u.name === CameraFirmwareType.arobaViewRa
            );
            if (arobaViewRaUpdateWithState1.length > 0) {
              this.$set(this.items[3], 'updating', true);
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
    routeModel: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.routeFrom = val.from;
        if (
          val?.from?.name === 'settings-firmware-details' &&
          this.canConfigCamera
        ) {
          !this.recordSetting && this.fetchCamRecordSettings();
        } else if (
          val?.from?.name !== 'settings-firmware-mode' &&
          this.canConfigCamera
        ) {
          this.fetchCamRecordSettings();
        }
      },
    },
    recordSetting: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.motionSettings) {
          this.motionDetection = !!val?.motionSettings?.value?.enable;
          if (this.motionDetection && val.motionSettings.value?.sensitivity) {
            let sensitivityIndex = this.motionSensitivities.findIndex(
              (item) => item.val === val.motionSettings.value.sensitivity
            );
            this.selectedMotionSensitivity =
              sensitivityIndex < 0
                ? this.defaultMotionSensitivity
                : sensitivityIndex;
          }
        }
      },
    },
  },
  mounted() {
    this.isMotion = this.currentRoute === SETTING_FIRMWARE_MOTION;
    this.checkUnavailableCamera();
  },
  beforeDestroy() {
    this.abortFetchCamRecordSettings();
  },
  methods: {
    ...mapActions('common', ['attachCamerasCredentials', 'abortHttpRequest']),
    ...mapActions('settings', [
      'fetchCamRecordInfo',
      'updateRecordSettings',
      'rebootCamera',
      'disableCameraMotion',
      'updateFirmwareDetail',
    ]),
    checkUnavailableCamera() {
      if (
        (this.allCamList || this.cameraList).findIndex(
          (cam) => +cam.id === +this.id
        ) === -1
      ) {
        this.routerPush({ name: 'settings-firmware' });
      }
    },
    validateInput() {
      this.isValid = validateInputName(this.newCamName).isValid;
    },
    handleCameraName() {
      if (!this.newCamName) {
        return;
      }
      this.newCamName = getFullWidthNumericHyphenUnderbar(this.newCamName);
      this.isValid = validateInputName(this.newCamName).isValid;
    },
    handleLoadMetadata(metadata) {
      this.videoMetadata = metadata;
    },
    handleVideoStreamEvent(e) {
      if (e.type === 'error') {
        const { error, code } = e.payload;
        if (error) {
          switch (code) {
            case KVSErrorCodes.GET_DATA_ENDPOINT_TOKEN_EXP:
              this.handleKVSExpiration({ error, code });
              break;
            case PlayerStatus.StreamingSessionExpired:
              this.handleStreamingSessionExpiration({ error, code });
              break;
            default:
              break;
          }
        }
      }
    },
    async handleKVSExpiration() {
      if (this.attachingCredentials) {
        return;
      }
      this.attachingCredentials = true;
      await this.attachCamerasCredentials({
        ids: [this.selectedCam.id],
      });
      this.attachingCredentials = false;
    },
    async handleStreamingSessionExpiration() {
      if (this.attachingCredentials) {
        return;
      }
      this.attachingCredentials = true;
      await this.attachCamerasCredentials({
        ids: [this.selectedCam.id],
      });
      this.attachingCredentials = false;
    },
    handleLowLatencyError() {
      this.$refs.firmawareDetails.disableLowLatencyMode();
    },
    async fetchCamRecordSettings() {
      try {
        this.loadingRecordSettings = true;
        this.fetchCamRecordInfoReqId = uuidv4().replaceAll('-', '');
        await this.fetchCamRecordInfo({
          cameraId: this.id,
          reqId: this.fetchCamRecordInfoReqId,
        });
        if (this.recordSetting?.motionSettings) {
          const groupStatus = this.flatStatusResponses(
            this.recordSetting.motionSettings.status
          );
          this.checkErrorStatus(groupStatus);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingRecordSettings = false;
      }
    },
    abortFetchCamRecordSettings() {
      if (!this.fetchCamRecordInfoReqId) {
        return;
      }
      const recordAbortKey = `${FetchCamRecordInfoKeys.getCamRecordSettings_}${this.fetchCamRecordInfoReqId}`;
      const imageAbortKey = `${FetchCamRecordInfoKeys.getCamImageSettings_}${this.fetchCamRecordInfoReqId}`;
      const motionAbortKey = `${FetchCamRecordInfoKeys.getCameraMotion_}${this.fetchCamRecordInfoReqId}`;

      this.abortHttpRequest(recordAbortKey);
      this.abortHttpRequest(imageAbortKey);
      this.abortHttpRequest(motionAbortKey);
    },
    flatStatusResponses(obj, prefix = '') {
      let flattenedObj = {};
      for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          const nestedKeys = this.flatStatusResponses(obj[key], prefix);
          flattenedObj = { ...flattenedObj, ...nestedKeys };
        } else {
          flattenedObj[key] = obj[key];
        }
      }
      return flattenedObj;
    },
    checkErrorStatus(obj) {
      let errorStatus = '';
      if (!!obj.cbesRecordMissingError || !!obj.numberOfRoisOverError) {
        errorStatus =
          '設定エリア情報が正しく取得できませんでした。<br>再設定をお願いいたします。';
      } else if (
        !!obj.cameraCommunicationError ||
        !!obj.cameraInstallError ||
        !!obj.otherError ||
        !!obj.otherValueError
      ) {
        errorStatus =
          'カメラが正常に動作していない可能性があります。<br>カメラの状態をご確認ください。';
      } else if (obj.sensitivityError) {
        errorStatus =
          '感度設定が正しく取得できませんでした。<br>再設定をお願いいたします。';
      } else if (!!obj.objsizeError || !!obj.polygonstdError) {
        errorStatus =
          'エリア設定が正しく取得できませんでした。<br>再設定をお願いいたします。';
      }
      // If some error returns, show a confirm dialog
      if (errorStatus) {
        dialogService.showConfirmDialog(
          {
            title: 'エラーがあります。',
            content: errorStatus,
            cancel: false,
          },
          {
            width: 525,
            height: 238,
            adaptive: true,
          }
        );
      }
    },
    async handleRebootCamera() {
      try {
        this.rebooting = true;
        await this.rebootCamera(this.id);
        this.closeDialogUpdateFirmware();
        await this.reconnectCam();
      } catch (error) {
        console.error(error);
      } finally {
        this.rebooting = false;
      }
    },
    async handleDisableMotion() {
      this.$refs.motionAreas?.clearAreaList();
      this.clearAreas = true;
      this.motionDetection = false;
      await this.disableCameraMotion(this.id);
      this.confirmDisableMotion = false;
    },
    async reconnectCam() {
      this.showVideo = false;
      if (this.reconnectCamTimeout) {
        clearTimeout(this.reconnectCamTimeout);
      }
      this.reconnectCamTimeout = setTimeout(() => {
        this.showVideo = true;
      }, 1000);
    },
    handleOpenRebootDialog() {
      this.dialogUpdateFirmwareOpen = true;
      this.routeFrom = null;
    },
    closeDialogUpdateFirmware() {
      this.dialogUpdateFirmwareOpen = false;
    },
    closeDialogConfirmDisableMotion() {
      this.motionDetection = true;
      this.confirmDisableMotion = false;
    },
    navigateTo(to) {
      this.isEdit = true;
      this.$router.push(to);
    },
    async handleSubmit() {
      this.submitLoading = true;
      try {
        await updateSettingCameraName({
          id: this.selectedCam.id,
          name: this.newCamName,
        });
        this.$set(this.selectedCam, 'name', this.newCamName);
        this.submitLoading = false;
        this.navigateTo({
          name: 'settings-firmware-details',
          params: { id: this.id },
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    handleMotionDetection() {
      if (!this.motionDetection && this.areaList.length) {
        this.confirmDisableMotion = true;
      }
    },
    updateAreaList(data) {
      this.areaList = data;
    },
    handleCamStatus(status) {
      this.cameraStatus = status;
    },
    handleUpdateFirmware(item) {
      // Set up confirm update version content
      this.firmwareName = item.type;
      this.updateWarnTitle =
        item.type === CameraFirmwareType.firmware
          ? 'ファームウェア更新'
          : 'パッケージ更新';
      this.updateWarnText =
        item.type === CameraFirmwareType.firmware
          ? 'ファームウェアの更新中は録画とライブが停止されます'
          : 'パッケージの更新中は録画とライブが停止されます';
      this.dialogConfirmUpdateFirmware = true;
    },
    async handleUpdateFirmwareOk() {
      this.updatingFirmware = true;
      try {
        const payload = {
          name: this.firmwareName,
          cameraIds: [this.selectedCam.id],
        };
        const result = await this.updateFirmwareDetail(payload);
        if (!result) {
          this.showErrorDialog();
        }
        this.dialogConfirmUpdateFirmware = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.updatingFirmware = false;
      }
    },
    showErrorDialog() {
      dialogService.showErrorDialog(
        {
          title: 'ファームウェア更新エラー',
          content: `ファームウェアの更新に失敗しました。<br>
                    しばらくたってからもう一度お試しください。`,
          cancel: false,
        },
        {
          classes: ['height-245'],
          width: 423,
        }
      );
    },
  },
};
</script>

<style lang="scss">
.firmwareDetails {
  position: relative;
  height: calc(100% - 56px);
  &--pointer {
    cursor: pointer;
  }
  &_wrapper {
    height: calc(100% - 5px);
    overflow-y: auto;
    @include scrollBarCustom;
    &.inMotionMode {
      min-width: 600px;
      main {
        @media (max-width: 1199px) {
          flex-direction: unset;
        }
      }
      .firmwareDetails_right {
        @media (max-width: 1199px) {
          padding: 0 10px;
          margin-bottom: 0;
        }
      }
    }
  }
  header {
    height: 15px;
  }

  &_flex-gap {
    display: flex;
    flex: 1;
  }
  &_divider {
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &_item {
    &--selected {
      background-color: #eee;
    }
  }
  header {
    height: 15px;
  }
  main {
    display: flex;
    flex-direction: row;
    @media (max-width: 1199px) {
      flex-direction: column-reverse;
    }
  }
  &-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }
  &-return {
    &.v-btn:not(.v-btn--round).v-size--default {
      padding: 0;
    }
  }
  &_tooltip {
    word-break: break-word;
    height: auto !important;
    width: auto !important;
    max-width: 350px !important;
    padding-bottom: 5px !important;
  }
  &_left {
    min-width: 410px;
    margin-right: 30px;
    .customCheck {
      padding: 12px 10px;
      &:not(:last-child) {
        border-bottom: 1px solid #eee;
      }
      &_label {
        width: 100%;
      }
    }
    & h3,
    &--items {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      &:first-child {
        padding: 10px 0;
      }
      &:not(:first-child) {
        padding: 15px 0;
      }
      border-bottom: 1px solid #eee;

      & span {
        display: inline-block;
        &:first-child {
          min-width: 220px;
          font-weight: bold;
          color: #4b4b4b;
        }
      }
      &Package {
        font-size: 12px;
        .text-truncate {
          color: #0075c2;
          font-size: 14px;
          padding: 10px 0;
          cursor: pointer;
        }
        span:first-child {
          color: #0075c2;
          padding: 10px 0;
          font-weight: normal;
        }
        span:not(:first-child) {
          color: #eb545b;
          font-weight: normal;
        }
      }
    }
  }
  &_right {
    margin-top: 32px;
    @media (max-width: 1199px) {
      padding: 0;
      margin-bottom: 10px;
    }
    .firmwareDetails_cam {
      position: relative;
      > .videoStream {
        gap: 5px;
        video {
          vertical-align: bottom;
        }
      }
      &.inMotionMode {
        border-bottom: 1px solid #eeeeee;
      }
    }

    h5 {
      margin-top: 5px;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
  &_btn {
    &-reset {
      margin: 10px 0;
      &.v-btn:not(.v-btn--round).v-size--default {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #0075c2;
        padding: 0;
      }
    }
  }
  &_dialog {
    position: relative;

    &-cancel {
      color: #989898 !important;
    }
    &-update {
      &.v-btn.v-btn--has-bg {
        background-color: #0075c2 !important;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
      }
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
      &--warn {
        font-weight: bold;
        color: #eb545b;
      }
    }
  }
  &_motion {
    &ItemsLoading {
      min-width: 220px;
      padding-left: 20px;
    }
    &Config {
      border-bottom: 1px solid #ccc;
      &Loading {
        width: 400px;
      }
      .motionConfig-item {
        width: 280px;
        height: 52px;
        padding: 0 10px;
        align-items: center;
        &:first-child:not(:last-child) {
          border-bottom: 1px solid #eeeeee;
        }
        &--name {
          font-size: 14px;
          font-weight: bold;
          color: #4b4b4b;
        }
        &--label {
          font-size: 14px;
          color: #989898;
          margin-right: 5px;
        }
        &--switch {
          width: 80px;
        }
      }
    }
    &--menu {
      width: 120px;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
      .v-list {
        padding: 0;
        &-item__icon {
          margin-right: 12px !important;
        }
        .v-list-item--link:before {
          background-color: white;
        }
        .v-item--active {
          .v-list-item__title {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
      &Btn {
        margin-top: 5px;
        &:before {
          border-radius: 50%;
          background-color: #989898;
        }
        &.v-btn:not(.v-btn--round).v-size--default {
          font-size: 18px;
          height: 31px;
          padding: 0 5px;
          min-width: 31px;
          margin-top: -2px;
          border-radius: 50%;
        }
        .icon {
          color: #989898;
        }
      }
    }
    &--menuBtn {
    }
  }
}
</style>
